import axios from "axios";
import React, { useEffect, useState } from "react";
import { APIURL } from "../Config";
import LoanDetails from "./LoanDetails";

export default function SearchDetails({ keyName, searchInput }) {
  const [data, SetData] = useState([]);
  const [lid, setLid] = useState("");
  const [show, setShow] = useState(false);
  const [isLoader, setIsLoader] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    if (keyName && searchInput) {
      searchHandler();
    }
  }, [keyName, searchInput]);

  const searchHandler = () => {
    setIsLoader(true);
    axios
      .request(`${APIURL}/loanCardDetails?${keyName}=${searchInput}`, {
        method: "GET",
        headers: {
          Authentication: token,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        console.log("response", response);
        setIsLoader(false);
        SetData(response?.data);
      })
      .catch((error) => {
        console.log(error);
        setIsLoader(false);
      });
  };
  return (
    <>
      {show ? (
        <>
          <div>
            <LoanDetails lid={lid} />
          </div>
        </>
      ) : (
        <>
          <div className="table-responsive">
            {isLoader ? (
              <div className="d-flex justify-content-center">
                <div className="spinner-border text-success" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th style={{ textAlign: "center" }}>Sr. No</th>
                    <th style={{ textAlign: "center" }}>Name</th>
                    <th style={{ textAlign: "center" }}>Mobile No </th>
                    <th style={{ textAlign: "center" }}>Email</th>
                    <th style={{ textAlign: "center" }}>PanCard</th>
                    <th style={{ textAlign: "center" }}>APP Id </th>
                    <th style={{ textAlign: "center" }}>Loan Id </th>
                    <th style={{ textAlign: "center" }}>Status</th>
                    <th style={{ textAlign: "center" }}>Remark</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>{item.name}</td>
                      <td>{item.mobileno}</td>
                      <td>{item.email}</td>
                      <td>{item.pancard}</td>
                      <td>{item.appclientid}</td>
                      <td
                        style={{
                          textAlign: "center",
                          whiteSpace: "normal",
                          fontSize: "15px",
                          color: "blue",
                          cursor: "pointer",
                        }}
                        onClick={() => {
                          if (item.loanid) {
                            setLid(item.loanid);
                            setShow(true);
                          }
                        }}
                      >
                        {item.loanid}
                      </td>
                      <td>{item.status}</td>
                      <td>{item.remark}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </>
      )}
    </>
  );
}
